/* eslint-disable */
export const DEFAULT_API_URL = `https://${process.env.NEXT_PUBLIC_API_HOST_NAME}`;

export const FEATURE_FLAGS_URL = `https://${process.env.NEXT_PUBLIC_NIKE_DOTCOM_DOMAIN}/static/experience/landing-pages-config/flags/prod.json`;

export const CONFIG_S3_URL = `https://${process.env.NEXT_PUBLIC_NIKE_DOTCOM_DOMAIN}/static/experience/landing-pages-config/config/prod.json`;

/**
 * Log prefix for Data Fetch Layer errors and messages
 * Used to identify logs originating from the data-fetch-layer package
 */
export const DFL_LOG_PREFIX = '[DFL]';
